export default function formatBytes(bytes, decimals) {
  if (bytes === 0) {
    return '0 Bytes'
  }

  const size = 1000
  const dm = decimals || 2
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const currentSizeindex = Math.floor(Math.log(bytes) / Math.log(size))
  const convertedSize = parseFloat((bytes / size ** currentSizeindex).toFixed(dm))

  return `${convertedSize} ${sizes[currentSizeindex]}`
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/formatBytes.js